// CALL_TO_BOOK is not bookable in the flow, despite being available. A user must call to book instead
// MIN_REQUIRED_NOT_BOOKABLE is in fact bookable once the minimum required quantity is reached.
// NOT_AVAILABLE is technically bookable, it's just not available
export const AVAILABLE_STATUSES: AvailabilityMode[] = ['AVAILABLE', 'CALL_TO_BOOK', 'MIN_REQUIRED_BOOKABLE', 'MIN_REQUIRED_NOT_BOOKABLE']
export const BOOKABLE_STATUSES: AvailabilityMode[] = ['AVAILABLE', 'NOT_AVAILABLE', 'MIN_REQUIRED_BOOKABLE', 'MIN_REQUIRED_NOT_BOOKABLE']

/**
 * Checks the given status against the list of available statuses.
 * "Available" means the timeslot represents real availability in the system.
 *
 * (e.g. capacity exists, not sold out, not blocked).
 */
export function isAvailableStatus(status: AvailabilityMode): boolean {
  return AVAILABLE_STATUSES.includes(status)
}

/**
 * Checks the given status against the list of bookable statuses.
 * "Bookable" means that the timeslot is SELECTABLE from within the flow.
 *
 * (e.g. CALL_TO_BOOK is not bookable in the flow, despite being available. A user must call to book instead)
 */
export function isBookableStatus(status: AvailabilityMode): boolean {
  return BOOKABLE_STATUSES.includes(status)
}
